import React from 'react';

interface ProjectCardProps {
  title: string;
  description: React.ReactNode;
  technologies: string;
  mediaType: 'image' | 'video';
  mediaSrc: string;
  mediaAlt?: string;
  links?: { label: string; href: string }[];
}

export default function ProjectCard({
  title,
  description,
  technologies,
  mediaType,
  mediaSrc,
  mediaAlt = '',
  links = [],
}: ProjectCardProps) {
  return (
    <div className="project-card">
      <div className="project-media">
        {mediaType === 'image' ? (
          <img src={mediaSrc} alt={mediaAlt} />
        ) : (
          <video controls>
            <source src={mediaSrc} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="project-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <p><b>Technologies:</b> {technologies}</p>
        {links.length > 0 && (
          <div className="project-links">
            {links.map((link, index) => (
              <a key={index} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}